import { z } from 'zod';

import { apiClient } from './client';

export const ContactTypeZ = z.enum(['owner', 'emergency', 'service']);

export const EmergencyContactZ = z.object({
  id: z.number().int(),
  lease_id: z.number().int().nullable().optional(),
  property_id: z.number().int().nullable().optional(),
  type: ContactTypeZ,
  name: z.string(),
  phone: z.string(),
  description: z.string().nullable().optional(),
});
export type EmergencyContact = z.infer<typeof EmergencyContactZ>;

const ListZ = z.object({ data: z.array(EmergencyContactZ) });

export async function listContacts(params: { lease_id?: number } = {}): Promise<EmergencyContact[]> {
  // backend route -- /contacts/emergency (не /emergency-contacts -> был 404).
  const res = await apiClient.get('/contacts/emergency', { params });
  return ListZ.parse(res.data).data;
}

export const contactsApi = { list: listContacts };
